export function getFormattedTime(ElapsedTime) {
  ElapsedTime = parseInt(ElapsedTime);
  var tt = "";
  var time = parseInt(ElapsedTime / 1140);
  if (time === 1) tt = time + "d ";
  else if (time > 1) tt = time + "d ";
  ElapsedTime = ElapsedTime - time * 1440;
  time = parseInt(ElapsedTime / 60);
  if (time > 0) tt += time + "h ";
  ElapsedTime = ElapsedTime - time * 60;
  tt += ElapsedTime + "m";
  return tt;
}

export function toHoursAndMinutes(totalMinutes) {
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);

  return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}`;
}

export function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function addMinutes(date, minutes) {
  date.setMinutes(date.getMinutes() + minutes);

  return date;
}
